<template>
  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow' : visible}"
    :style="visible ? 'display:block;': ''"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><b>{{item}}</b></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="handleCloseModal">
          <span aria-hidden="true">&times;</span>
        </button>
        </div>
        <div class="modal-body text-center mt-4">
            <span class="material-icons text-danger" style="font-size: 77px"> remove_shopping_cart </span>
          <h5 class="modal-title" v-html="modalText"></h5>
          
        </div>
        <div class="p-3 text-center">
          <span class="btn btn-secondary mr-2" @click="handleCloseModal">Seguir navegando</span>
          <span class="btn btn-danger" @click="handleClickSend">Vaciar carrito</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModalAddItemCartError",
  props: {
    item: String,
    visible: Boolean,
    sellerCart: String,
    seller: String,
    text: {
      type: String,
      default: "DIFFERENT_SELLER"
    }
  },
  methods: {
    handleCloseModal(){
      this.$emit('close')
    },
    handleClickSend(){
      this.$emit('send')
    },
  },
  computed: {
    modalText(){
      switch (this.text) {
        case "DIFFERENT_SELLER":
          return `Ups, solo se pueden agregar articulos al carrito del mismo venderdor, y ya tienes articulos ingresados de <b>${this.sellerCart}</b>!`
      
        case "DIFFERENT_KIND":
          return `Ups, no se pueden comprar servicios y productos a la vez.`
        default:
          return "Por algun motivo no puedes agregar este producto al carrito"
      }
    }
  }
};
</script>
<style lang="css" scoped>
</style>